// Pure helpers for the CMS users screen; goserver enforces the same with a 403.
export const SUPER_USER_ONLY_TIP = 'Only a Super user can change a Super user';

export const has_super_user = (access_type) =>
  (access_type || '')
    .split(',')
    .map((t) => t.trim().toUpperCase())
    .includes('SUPER_USER');

// Non-super viewers cannot grant SUPER_USER, so it is left out of the role options.
export const visible_access_types = (types, viewer_is_super) =>
  (types || []).filter((t) => viewer_is_super || String(t).trim().toUpperCase() !== 'SUPER_USER');

// A non-super viewer cannot edit a row that holds SUPER_USER.
export const can_edit_user = (user, viewer_is_super) =>
  viewer_is_super || !has_super_user(user && user.access_type);

// Payment roles open bank details and teacher-app payment edits, so only the payments owners grant
// or remove them (goserver refuses anyone else with 403).
export const PAYMENT_ROLES = ['TEACHER_OPS_PAYMENT', 'TEACHER_PAYMENT_SUPER_USER'];
export const PAYMENT_ROLE_OWNERS = [
  'kuldeep@myyogateacher.com',
  'jitendra@myyogateacher.com',
  'vaibhaw@myyogateacher.com'
];
export const PAYMENT_ROLES_LOCKED_NOTE =
  'Only Kuldeep, Jitendra or Vaibhaw can change payment roles';

const norm_role = (r) =>
  String(r || '')
    .trim()
    .toUpperCase();
export const is_payment_role = (role) => PAYMENT_ROLES.includes(norm_role(role));

export const can_change_payment_roles = (viewer_email) =>
  PAYMENT_ROLE_OWNERS.includes(
    String(viewer_email || '')
      .trim()
      .toLowerCase()
  );

// Multi-select options with the payment roles disabled for a non-owner.
export const access_type_options_for = (types, can_change_payment) =>
  (types || []).map((t) => ({
    value: t,
    label: t,
    disabled: !can_change_payment && is_payment_role(t)
  }));

// A non-owner's change never adds or drops a payment role (the clear-all button included):
// payment roles come from prev, everything else from next.
export const guard_payment_roles = (prev, next, can_change_payment) => {
  if (can_change_payment) return next || [];
  const kept = (prev || []).filter((o) => is_payment_role(o.value));
  return kept.concat((next || []).filter((o) => !is_payment_role(o.value)));
};
